export const VITALS_TESTS_FIELDS ={
    DEVICE_NAME:"deviceName",
    TEST_NAME: 'testName',
    CHARGE:"charge",
    ACTION:"action",
}